import download from 'downloadjs';
// import type { Id } from 'flowTypes/common';
import moment from 'moment';
import { map } from 'ramda';

import request from 'utils/request';

import { keysToSnakeCaseDeep } from '../utils/stringUtils';

// type QuoteOption = {|
//   quantityId: Id,
//   expediteId: ?Id,
// |};

// type ItemGroups = {
//   [string]: Array<QuoteOption>,
// };

export const transformQuoteOptionsToApi = (data) => {
  return data instanceof Object
    ? {
        quantity_id: data.quantityId,
        expedite_id: data.expediteId || null,
      }
    : data;
};

export const transformItemGroupsToApi = (data) => {
  return Object.keys(data).map((name) => ({
    name,
    items: map(transformQuoteOptionsToApi, data[name]),
  }));
};

const getCheckoutFormData2 = (data) => {
  const formData = new FormData();
  const dat = {
    ...data,
    cardToken: data.stripeToken,
    itemQuantities: data.quoteOptions || data.selectedOptionsList || [],
    purchaseToken: data.purchaseOrderNumber,
    sendCustomerConfirmation: data.withConfirmation,
    shippingOption: data.shippingOption && {
      type: data.shippingOption.type,
      shippingMethod: data.shippingOption.method,
      shipWhen: data.shippingOption.grouping,
      customersAccountNumber: data.shippingOption.customerAccount,
      customersCarrier: data.shippingOption.customerCarrier,
    },
    supplierSubmitted: data.facilitate,
  };
  if (data.purchaseOrderFile) {
    formData.append('po_file', data.purchaseOrderFile);
  }
  formData.append('data', JSON.stringify(keysToSnakeCaseDeep(dat)));
  return formData;
};

export default {
  checkout: async (data) => {
    const formData = getCheckoutFormData2(data);
    return await request.post('/orders/digiquote/create', formData);
  },

  getShippingEstimation: async (quoteKey, data) => {
    const response = await request.post(
      `/quotes/key/${quoteKey}/shipping_estimation`,
      {
        item_groups: Object.keys(data).map((key) => ({
          name: key,
          items: data[key],
        })),
      },
    );
    for (const key in response)
      response[key].shipsOn = moment(response[key].shipsOn);
    return response;
  },

  getShippingRates: async (quoteKey, data) => {
    const response = await request.post(
      `/quotes/key/${quoteKey}/shipping_rates`,
      {
        address: data.address,
        item_groups: Object.keys(data.itemGroups).map((key) => ({
          name: key,
          items: data.itemGroups[key],
        })),
      },
    );
    Object.keys(response.shippingRates).forEach((key) => {
      response.shippingRates[key].forEach((rate) => {
        rate.arrivesOn = moment(rate.arrivesOn);
      });
    });
    return response;
  },

  createStripeAccount: async (groupId) =>
    await request.post(`/payments/${groupId}/stripe_account`),

  getStripeOnboardingLink: async (groupId) =>
    await request.get(`/payments/${groupId}/stripe_account/urls`),

  downloadChargeReceiptsCsv: async (groupId) => {
    const response = await request.get(
      `/payments/${groupId}/charge_receipts_csv_download`,
    );
    const blob = new Blob([response], {
      type: 'text/plain',
    });
    download(blob, `charges-${Date.now()}.csv`);
  },

  verifyBankAccount: async (groupId, data) =>
    await request.post(`/payments/${groupId}/verify_bank_account`, data),
};
